// extracted by mini-css-extract-plugin
module.exports = {"container":"CenteredContainer__container___u23av","content":"CenteredContainer__content___afXVc"};